import { render, staticRenderFns } from "./DealListEntry.vue?vue&type=template&id=72e7d6d5&scoped=true&"
import script from "./DealListEntry.vue?vue&type=script&lang=js&"
export * from "./DealListEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7d6d5",
  null
  
)

export default component.exports